export default __webpack_public_path__ + "static/media/lvmh-ethics-compliance.3a7d4ee7.png";